import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class AIAssistantService {
    constructor(environment, authManager) {
        this.environment = environment;
        this.authManager = authManager;
    }
    async getConversations() {
        const orgId = this.authManager.orgId;
        if (!orgId)
            throw new Error("Organization ID is missing.");
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${orgId}/conversations`, authenticatedApiConfig(this.authManager));
        return response.data;
    }
    async createConversation(title) {
        const orgId = this.authManager.orgId;
        if (!orgId)
            throw new Error("Organization ID is missing.");
        const response = await axios.post(`${this.environment.API_BASE_URL}/organizations/${orgId}/conversations`, { title: title !== null && title !== void 0 ? title : "New Conversation" }, authenticatedApiConfig(this.authManager));
        return response.data;
    }
    async getConversationMessages(conversationId) {
        const orgId = this.authManager.orgId;
        if (!orgId)
            throw new Error("Organization ID is missing.");
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${orgId}/conversations/${conversationId}/messages`, authenticatedApiConfig(this.authManager));
        return response.data;
    }
    async renameConversation(conversationId, title) {
        const orgId = this.authManager.orgId;
        if (!orgId)
            throw new Error("Organization ID is missing.");
        await axios.post(`${this.environment.API_BASE_URL}/organizations/${orgId}/conversations/${conversationId}/rename`, { title }, authenticatedApiConfig(this.authManager));
    }
    async deleteConversation(conversationId) {
        const orgId = this.authManager.orgId;
        if (!orgId)
            throw new Error("Organization ID is missing.");
        await axios.delete(`${this.environment.API_BASE_URL}/organizations/${orgId}/conversations/${conversationId}`, authenticatedApiConfig(this.authManager));
    }
    async call(query, conversationId, callbacks) {
        var _a, _b, _c, _d, _e, _f;
        const orgId = this.authManager.orgId;
        if (!orgId)
            throw new Error("Organization ID is missing.");
        try {
            const response = await fetch(`${this.environment.API_BASE_URL}/organizations/${orgId}/chat`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${this.authManager.token}`,
                },
                body: JSON.stringify({
                    query,
                    conversationId,
                }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const reader = (_a = response.body) === null || _a === void 0 ? void 0 : _a.getReader();
            if (!reader)
                throw new Error("Response body is null.");
            const decoder = new TextDecoder();
            let buffer = "";
            let isReading = true;
            while (isReading) {
                const { done, value } = await reader.read();
                if (done) {
                    isReading = false;
                    break;
                }
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split("\n\n");
                buffer = (_b = lines.pop()) !== null && _b !== void 0 ? _b : "";
                for (const line of lines) {
                    if (line.startsWith("data: ")) {
                        const data = line.slice(6);
                        if (data === "[DONE]") {
                            (_c = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onComplete) === null || _c === void 0 ? void 0 : _c.call(callbacks);
                            return;
                        }
                        if (data) {
                            const decodedData = data.replace(/\\n/g, "\n").replace(/\\r/g, "\r");
                            (_d = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onToken) === null || _d === void 0 ? void 0 : _d.call(callbacks, decodedData);
                        }
                    }
                }
            }
            if (buffer) {
                const data = buffer.slice(6);
                if (data && data !== "[DONE]") {
                    (_e = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onToken) === null || _e === void 0 ? void 0 : _e.call(callbacks, data);
                }
            }
            (_f = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onComplete) === null || _f === void 0 ? void 0 : _f.call(callbacks);
        }
        catch (error) {
            console.error("Streaming error:", error);
            throw error;
        }
    }
}
